/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';

export const useSupportPlanCardStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      cursor: 'pointer',
      padding: '16px',
      backgroundColor: theme.palette.scalefieldCardBackground.main,
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
    },
    planName: {
      color: theme.palette.primary.main,
      fontSize: '16px',
      lineHeight: '16px',
      fontWeight: 'bold',
    },
    planDescription: {
      fontSize: '12px',
      lineHeight: '12px',
      color: theme.palette.text.primary,
      fontWeight: 400,
    },
    price: {
      display: 'flex',
      flexDirection: 'row',
      gap: '5px',
      alignItems: 'baseline',
    },
    priceAmount: {
      color: theme.palette.primary.main,
      fontSize: '24px',
      lineHeight: '24px',
      fontWeight: 400,
    },
    priceDuration: {
      color: theme.palette.text.primary,
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 400,
    },
  }),
);
